// Module
var code = "<div ui-view=\"odpocty\"></div> <div class=\"col-md-6\" ui-view=\"list\" style=\"padding:0\"></div> <div class=\"col-md-6\" ui-view=\"add\" style=\"padding:0\"></div> ";
// Exports
module.exports = code;